<template>
	<CRow>
		<CCol lg="12" class="wrapper-active-field">
			<label class="switch-active-label">
				{{ label }}
			</label>
			<CSwitch
				:checked="input"
				:disabled="disabled"
				name="status"
				variant="3d"
				size="sm"
				color="success"
				class="switch-custom swtich-active-status-button"
				@update:checked="handleChange"
			/>
			<p class="label-active-status typo-body-2">
				{{ stateText }}
			</p>
		</CCol>
	</CRow>
</template>

<script>
export default {
	name: 'BaseSwitch',

	props: {
		value: {
			type: Boolean,
			default: false,
		},
		label: {
			type: String,
			default: '',
		},
		checkedText: {
			type: String,
			default: '',
		},
		uncheckedText: {
			type: String,
			default: '',
		},
		disabled: {
			type: Boolean,
			default: false,
		},
	},

	data() {
		return {
			input: false,
		};
	},

	computed: {
		stateText() {
			if (this.input) {
				return this.checkedText;
			}
			return this.uncheckedText;
		},
	},

	watch: {
		input() {
			this.$emit('input', this.input);
		},
		value() {
			this.input = this.value;
		},
	},

	created() {
		this.input = this.value;
	},

	methods: {
		handleChange(checked) {
			this.input = checked;
		},
	},
};
</script>

<style lang="scss" scoped>
.wrapper-active-field {
	display: flex;
	align-items: center;

	.switch-active-label {
		margin-right: rem(40);
		margin-bottom: 0;
	}

	.swtich-active-status-button {
		margin-right: rem(12);
	}

	.label-active-status {
		margin-bottom: 0;
	}
}
</style>